export const isTimeTracker = (value: string) => {
    const regEx = /\[\d/;
    const match = value.match(regEx);
    return !!match;
}
